import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IHouseholdComposition {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllHouseholds?: number | null;
  onePersonHousehold?: number | null;
  singleFamilyHousehold?: number | null;
  otherHouseholdTypes?: number | null;
}

export const defaultValue: Readonly<IHouseholdComposition> = {};
